import { Link } from "react-router-dom";
import { Logo } from "@/components";

const Footer = () => {
  return (
    <footer className="border-t border-border bg-muted/30" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-8">

          {/* Coluna 1: Sobre / Logo */}
          <div className="space-y-10">
            <Link to="/">
              <Logo
                textClassName="bg-clip-text text-transparent bg-linear-to-r from-primary to-primary/80"
              />
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-sm mt-6">
              O portal de referência sobre a Lei do Cadastro Imobiliário Brasileiro.
              Criado sem fins lucrativos para fornecer informações oficiais e atualizadas
              para profissionais do mercado imobiliário e cidadãos.
            </p>
          </div>

          {/* Coluna 2: Explorar */}
          <div>
            <h3 className="font-semibold mb-4 text-foreground">Explorar</h3>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li>
                <a href="/dicionario" className="hover:text-primary transition-colors block py-1">
                  Dicionário Imobiliário
                </a>
              </li>
              <li>
                <a href="/noticias" className="hover:text-primary transition-colors block py-1">
                  Notícias
                </a>
              </li>
              <li>
                <a href="/cursos" className="hover:text-primary transition-colors block py-1">
                  Cursos
                </a>
              </li>
              <li>
                <a href="/ferramentas" className="hover:text-primary transition-colors block py-1">
                  Ferramentas
                </a>
              </li>
              {/* <li>
                <a href="/#newsletter" className="hover:text-primary transition-colors block py-1">
                  Newsletter
                </a>
              </li> */}
            </ul>
          </div>

          {/* Coluna 3: Legal */}
          <div>
            <h3 className="font-semibold mb-4 text-foreground">Institucional</h3>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li>
                <a href="/sobre" className="hover:text-primary transition-colors block py-1">
                  Sobre o Portal
                </a>
              </li>
              <li>
                <a href="/privacy" className="hover:text-primary transition-colors block py-1">
                  Política de Privacidade
                </a>
              </li>
              <li>
                <a href="/terms" className="hover:text-primary transition-colors block py-1">
                  Termos de Uso
                </a>
              </li>
              <li>
                <a href="mailto:contato@portalcib.online" className="hover:text-primary transition-colors block py-1">
                  Contato
                </a>
              </li>
            </ul>
          </div>

        </div>

        <div className="pt-8 border-t border-border text-center text-sm text-muted-foreground flex flex-col md:flex-row justify-between items-center gap-4">
          <p>Portal Não Oficial do Cadastro Imobiliário Brasileiro.</p>
          <p className="text-xs">© 2026 | Todos os direitos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;